var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:[
	'alert__browser',
	_vm.position
]},[_c('span',{class:_vm.icon},[_c('span',{staticClass:"path1"}),_c('span',{staticClass:"path2"})]),_c('p',[_vm._v(_vm._s(_vm.$t(_vm.text)))]),_c('IBButton',{staticClass:"link-blue",on:{"click":_vm.onClickModalBrowserList}},[_vm._v(" "+_vm._s(_vm.$t('alert.supportBrowser'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }